import './index.css'
import React, {useState} from 'react';
function App() {
  const [open , setOpen] = useState(true)
  return (
    <div class="wrapper">
     <div class="banner">
       <div class="header">                      
       <h1 class="logo">Sunnyside</h1>
        
      <div class={open ? 'menu': 'menu'} onClick={()=> setOpen(false)}>
        <span>About</span>
        <span>Services</span>
        <span>Projects</span>
      <div class="contact">
            Contact
        </div>
       

       
        <div class="mobile-menu-icon">
           <img  open={open} onClick={()=> setOpen(!open)} src="/images/assets/icon-hamburger.svg"/>
        </div>
       
       
        </div>
        </div>

        <div class="main">
                <span class="text">WE ARE CREATIVES</span>
                <img class="arrow" src="https://i.ibb.co/MSv2H70/arrow.png"/>
            </div>

        </div>
        <div class="section1">
           <div class="left">
              <div class="text-container">
             <h1>Transform your brand</h1>
             <p>We are a full-service creative agency specializing in helping
                        brands grow fast. Engage your clients through compelling visuals
                        that do most of the marketing for you.</p>
              <div class="button">
              <img src="https://i.ibb.co/TB2DVgK/learnmore.png"/>
              </div>
           </div>
        </div>
        <div class="right">
        <img src="/images/assets/image-transform.jpg"/>
        </div>
        </div>
        <div class="section1"> 
           <div class="left">
        <img src="/images/assets/image-stand-out.jpg"/>
        </div>
          <div class="right">
          <div class="text-container">
         <h1>Stand out to the right audiunce</h1>
         <p>We are a full-service creative agency specializing in helping
                        brands grow fast. Engage your clients through compelling visuals
                        that do most of the marketing for you.</p>
              <div class="button">
              <img src="https://i.ibb.co/TB2DVgK/learnmore.png"/>
              </div>
          </div>
          </div>
          </div>
        <div class="section2">
        <div class="left">
          <h1>Graphic Design</h1>
          <p>Great design makes you memorable. We deliver artwork that underscrores your brand message and captures potential clients attention</p> 
        </div>
        <div class="right">
        <h1>Photography</h1>
          <p>Great design makes you memorable. We deliver artwork that underscrores your brand message and captures potential clients attention</p> 
            </div>
        </div>
        <div class="section3 testimonials">
         <h1>CLIENT TESTIMONIALS</h1>
         <div class="clients">
         <div class="client">
           <div class="client-image">
           <img src="/images/assets/image-emily.jpg"/>          
           </div>
         <p>
         We put our trust in Sunnyside and they delivered, making sure our
           needs were met and deadlines were always hit.
       </p>
       <div class="details">
       <h2>Emily R.</h2>
         <h4>Marketing Director</h4>
       </div>
       </div>
       <div class="client">
           <div class="client-image">
           <img src="/images/assets/image-thomas.jpg"/>          
           </div>
         <p>
         We put our trust in Sunnyside and they delivered, making sure our
           needs were met and deadlines were always hit.
       </p>
       <div class="details">
       <h2>Emily R.</h2>
         <h4>Marketing Director</h4>
       </div>
       </div>
       <div class="client">
           <div class="client-image">
           <img src="/images/assets/image-jennie.jpg"/>          
           </div>
         <p>
         We put our trust in Sunnyside and they delivered, making sure our
           needs were met and deadlines were always hit.
       </p>
       <div class="details">
       <h2>Emily R.</h2>
         <h4>Marketing Director</h4>
       </div>
       </div>
         </div>
        </div>

        <div class="section4 examples">
        <div class="example-container">
                <img src="/images/assets/image-gallery-milkbottles.jpg"/>
            </div>
            <div class="example-container">
                <img src="/images/assets/image-gallery-orange.jpg"/>
            </div>
            <div class="example-container">
                <img src="/images/assets/image-gallery-cone.jpg"/>
            </div>
            <div class="example-container">
                <img src="/images/assets/image-gallery-sugarcubes.jpg"/>
            </div>
        </div>
        <div class="footer">
        <div>
                <h1 class="logo">Sunnyside</h1>
            </div>
            <div class="footer-navigation">
                <span>About</span>
                <span>Services</span>
                <span>Projects</span>
            </div>
            <div class="social-media">
                <img src="/images/assets/icon-facebook.svg"/>
                <img src="/images/assets/icon-instagram.svg"/>
                <img src="/images/assets/icon-twitter.svg"/>
                <img src="/images/assets/icon-pinterest.svg"/>
            </div>
        </div>
       </div>
  );
}

export default App;
